import React from 'react'
import { usePostRequest } from '../hooks/request'
import { QQC_QUARTERLY_LIST } from '../urls'
import QqcQuarterlyForm from './QqcQuarterlyForm'

export default function QqcQuarterlyCreate({ onCancel, onSuccess }) {
    const rotationCreate = usePostRequest({ url: QQC_QUARTERLY_LIST })

    async function onSubmit(data, actions) {
        const { success } = await rotationCreate.request({ data })

        if (success) {
            onSuccess()
            actions.resetForm()
        }
    }

    return (
        <div>
            <b>Добавить</b><br /><br />
            <QqcQuarterlyForm onSubmit={onSubmit} onCancel={onCancel} loading={rotationCreate.loading} />
        </div>
    )
}
